<template>
  <el-dialog
    v-dialogDrag
    :title="title + '来源'"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    class="mid-dialog"
  >
    <el-form :model="formData" label-width="160px" :rules="formRules" ref="formRef">
      <el-form-item label="来源编码" prop="sourceCode">
        <el-input v-model="formData.sourceCode" maxlength="50" clearable></el-input>
      </el-form-item>
      <el-form-item label="来源名称" prop="alarmSource">
        <el-input v-model="formData.alarmSource" maxlength="50" clearable></el-input>
      </el-form-item>
      <el-form-item label="报警音效" prop="alarmSoundId">
        <FileUpload
          :accept="['mp3', 'wav']"
          :maxSize="3"
          :limit="1"
          v-model="formData.alarmSoundId"
        ></FileUpload>
      </el-form-item>
      <el-form-item label="光影特效" prop="shadow">
        <el-select v-model="formData.shadow" filterable clearable @change="changeShadow">
          <el-option
            v-for="item in shadowList"
            :key="item.value"
            :value="item.value"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="特效时长" prop="effectDuration">
        <el-input v-model="formData.effectDuration" clearable  oninput="value = value.replace(/[^\d]/g,'')">
          <span slot="append">s</span>
        </el-input>
      </el-form-item>
      <el-form-item label="是否启用" prop="isOpen">
        <el-select v-model="formData.isOpen" filterable clearable>
          <el-option
            v-for="item in enableList"
            :key="item.value"
            :value="item.value"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跳转方式" prop="jumpMethod">
        <el-select v-model="formData.jumpMethod" filterable @change="changeJumpMethod">
          <el-option
            v-for="item in jumpMethodList"
            :key="item.value"
            :value="item.value"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跳转链接" prop="jumpLink" v-if="formData.jumpMethod === 0">
        <el-input v-model="formData.jumpLink" clearable></el-input>
      </el-form-item>
      <template v-if="formData.jumpMethod === 1">
        <el-form-item label="方案选择" prop="schemeSelection">
          <el-select v-model="formData.schemeSelection" filterable clearable @change="changeScheme">
            <el-option
              v-for="item in schemeList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="板块选择" prop="blockSelection">
          <el-select v-model="formData.blockSelection" filterable clearable @change="changeSection">
            <el-option
              v-for="item in sectionList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模块选择" prop="moduleSelection">
          <el-select v-model="formData.moduleSelection" filterable clearable>
            <el-option
              v-for="item in functionList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
    </el-form>
    <div slot="footer">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep, isEmpty, find, pick, map, get, filter, omitBy, isNil } from 'lodash'
import { AlarmSourceConfigurationTableApi } from '@wiz-api/cloud-render-management'

const alarmSourceConfig = new AlarmSourceConfigurationTableApi()
const FileUpload = () => {
  return import('./FileUpload')
}

export default {
  components: {
    FileUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'create',
    },
    operateProps: {
      type: Object,
      default: () => {},
    },
    shadowList: {
      type: Array,
      defalut: () => [],
    },
    enableList: {
      type: Array,
      defalut: () => [],
    },
    schemeList: {
      type: Array,
      defalut: () => [],
    },
    // 所有的板块列表
    allSectionList: {
      type: Array,
      defalut: () => [],
    },
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        sourceCode: '',
        alarmSource: '',
        // 报警音效
        alarmSoundId: '',
        // 光影特效
        shadow: '',
        // 特效时长
        effectDuration: '',
        isOpen: true,
        // 跳转方式
        jumpMethod: '',
        // 跳转链接
        jumpLink: '',
        // 跳转方案
        schemeSelection: '',
        // 跳转板块
        blockSelection: '',
        // 跳转模板
        moduleSelection: '',
      },
      formRules: {
        sourceCode: { required: true, message: '请输入来源编码', trigger: 'blur' },
        alarmSource: { required: true, message: '请输入来源名称', trigger: 'blur' },
        effectDuration: { required: true, message: '请输入特效时间', trigger: 'blur' },
        jumpLink: { required: true, message: '请输入跳转链接', trigger: 'blur' },
        jumpMethod: { required: true, message: '请选择跳转方式', trigger: 'change' },
        schemeSelection: { required: true, message: '请选择跳转方案', trigger: 'change' },
        blockSelection: { required: true, message: '请选择板块', trigger: 'change' },
        moduleSelection: { required: true, message: '请选择模块', trigger: 'change' },
      },
      jumpMethodList: [
        {
          value: 0,
          name: '跳转后台模块',
        },
        {
          value: 1,
          name: '跳转三维模块',
        },
      ],
      // 当前所选方案下的板块列表
      sectionList: [],
      // 当前所选板块下的模块
      functionList: [],
    }
  },
  computed: {
    title() {
      if (this.operateType === 'create') {
        return '新增'
      }
      return '编辑'
    },
  },
  async created() {
    if (!isEmpty(this.operateProps)) {
      // 跳转到三维板块
      if (this.operateProps.jumpMethod === 1) {
        // 下拉框列表赋值
        this.changeScheme(this.operateProps.schemeSelection)
        this.changeSection(this.operateProps.blockSelection)
      }
      this.formData = cloneDeep(this.operateProps)
    }
    this.changeShadow(this.formData.shadow)
  },
  methods: {
    // 选择跳转模式
    changeJumpMethod() {
      this.formData.jumpLink = ''
      this.formData.schemeSelection = ''
      this.formData.blockSelection = ''
      this.formData.moduleSelection = ''
    },
    // 选择方案清空板块下拉框选项
    changeScheme(value) {
      this.formData.blockSelection = ''
      this.formData.moduleSelection = ''
      if (!isEmpty(value)) {
        this.sectionList = filter(this.allSectionList, ['schemeId', value])
      }
    },
    // 选择板块清空功能选择下拉框选项
    changeSection(value) {
      this.formData.moduleSelection = ''
      if (!isEmpty(value)) {
        const section = find(this.sectionList, ['id', value])
        this.functionList = map(get(section, 'extraDto.businessFunctionInfoDtos'), (item) => {
          return pick(item, ['id', 'name'])
        })
      }
    },
    // 如果有特效，特效时间为必填
    changeShadow(val) {
      if (val !== '' && !isNil(val)) {
        this.formRules.effectDuration = {
          required: true,
          message: '请输入特效时间',
          trigger: 'blur',
        }
      } else {
        this.formRules.effectDuration = {}
      }
    },
    // 关闭弹框
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 保存
    save() {
      this.$refs.formRef.validate(async (valid) => {
        this.saveLoading = true
        if (valid) {
          let [err, res] = [null, null]
          if (this.operateType === 'create') {
            ;[err, res] = await alarmSourceConfig.create({
              body: omitBy(this.formData, (e) => isNil(e) || e === ''),
            })
          } else {
            ;[err, res] = await alarmSourceConfig.update(this.operateProps.id, {
              body: omitBy(this.formData, (e) => isNil(e) || e === ''),
            })
          }
          if (!err) {
            this.$message({
              showClose: true,
              message: this.title + '成功',
              type: 'success',
            })
            this.$emit('refresh')
            this.$emit('update:visible', false)
          }
        }
        this.saveLoading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
